<template>
  <el-container>
    <el-header v-if="!isMobile" height="56px">
      <img class="logo" src="@/assets/logo.png" />
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BasicLayout",
  computed: {
    ...mapGetters("screenStore", ["isMobile"]),
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  background: #fff;
}
.logo {
  height: 30px;
  margin: 13px 2px;
}

.el-main {
  // background-color: #ffffff;
  padding: 0;
}
</style>
